import React from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

import useDidMount from '@divvy-web/hooks.usedidmount'
import { FormattedMessage } from '@divvy-web/i18n'
import Spinner from '@divvy-web/skylab.spinner'
import { TOAST_TYPE_DEFAULT, useToast } from '@divvy-web/skylab.toast'

import { useAuth } from '@sputnik/auth'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { logInfo } from '@sputnik/utils/loggerUtils'

const AutoLoginPage = () => {
  const { search } = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const accessCode = searchParams.get('access_code')?.trim()
  const queryEmail = searchParams.get('email')?.trim()?.replace(/ /g, '+')

  const { verifyAuthCode, requestAuthCode } = useAuth()
  const showToast = useToast()

  useDidMount(() => {
    if (queryEmail && accessCode) {
      verifyAuthCode(accessCode, queryEmail).catch(() => {
        requestAuthCode(queryEmail).then(() => {
          showToast(
            TOAST_TYPE_DEFAULT,
            <FormattedMessage
              defaultMessage='The auth code provided was not valid, so we requested a new one. Check your email!'
              id='sputnik.AutoLoginPage__dAYTIn'
            />,
            { autoHideDelay: 10000 },
          )
          navigate(
            { pathname: `/${PATHNAME_CONSTS.AUTH_PATH_ABSOLUTE}/${PATHNAME_CONSTS.VERIFY_PATH}`, search },
            { replace: true },
          )
        })
      })
      return
    } else if (queryEmail) {
      requestAuthCode(queryEmail)
        .then(() => {
          navigate(
            { pathname: `/${PATHNAME_CONSTS.AUTH_PATH_ABSOLUTE}/${PATHNAME_CONSTS.VERIFY_PATH}`, search },
            { replace: true },
          )
        })
        .catch(() => {
          navigate({ pathname: PATHNAME_CONSTS.AUTH_PATH, search }, { replace: true })
        })
      return
    }

    logInfo('autoLoginPageLoad', {
      attributes: {
        result: 'Auto login page loaded',
      },
      eventName: 'PageLoad',
    })

    navigate(PATHNAME_CONSTS.AUTH_PATH)
  })

  return <Spinner fullPage />
}

export default AutoLoginPage
